// extracted by mini-css-extract-plugin
export var infoItem = "_uh-2";
export var title = "_uh-0";
export var value = "_uh-1";